<template>
    <v-layout
      text-xs-center
      wrap
      pt-3
    >
      <v-flex xs12>
          <h1>Give Ticket/Rights to New Person</h1>
          <h1>새로운 멤버에게 대표자 권한과 티켓 동시 양도하기</h1>
      </v-flex>

      <v-layout row v-if="mode_complete">
        <v-flex xs12>
            Processing Complete / 완료
	    <br/>
	    <v-btn color='error' :to="`/events/${this.$route.params.event_id}`" >OK</v-btn>
        </v-flex>
      </v-layout>

      <v-layout row v-if="mode_confirm">
        <v-flex xs12>
            <b>Is this the right person?</b>

            <br/>
            {{ attendee.full_name }} / {{ attendee.native_name }} / {{ attendee.nickname }}
            <br/>
            에게 팀 대표자 권한을 넘깁니다. 
            <br/>  
                                                                                                               
            <v-alert                                           
              :value="true"                                                              
              type="info"                                                                                                                  
            >      
		 새로운 멤버에게 팀 대표자 권한과 본인의 티켓을 양도합니다. 이후 팀 관리 및 행사 참석이 불가능합니다. 동의하십니까?
		 <br/>
		 Your team management rights AND your ticket are being transfered to the person above.  After this, you will have no rights to this ticket or team management.
            </v-alert>                                                              
                                                
                   
            <v-btn xs4 color='success' @click="confirm">Transfer/넘기기</v-btn>                            
            <v-btn xs4 color='error' @click="cancel_confirm">Cancel/취소</v-btn>

            {{ error_message }}
        </v-flex>
      </v-layout>

      <v-flex xs12 v-if="mode_select" class='choices'>
        <v-form ref="form">                         
          <v-layout row wrap  justify-center>               
            <v-flex xs6 sm6 md3>                            
              <v-text-field                                 
                outline                         
                class='display_upcase'          
                v-model="code"                                              
                :rules="[rules.reasonable_length]"                          
                :error-messages="code_error_messages"                       
                label="Member Code"                                         
              ></v-text-field>                                              
            </v-flex>                                                       
                                                                            
            <v-flex xs6 sm6 md3>                                            
              <v-btn color="primary" @click="lookup">Check/확인</v-btn>
            </v-flex>                       
          </v-layout>                       
        </v-form>                     
      </v-flex >
      <v-flex text-xs-center align-center v-if="mode_select">
        <v-btn color='error' :to="`/events/${this.$route.params.event_id}/my_team`" >Cancel</v-btn>
      </v-flex>
      <br/>
      <br/>
      <hr/>
      {{ user_agent }}
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import {fetcher} from '@/fetcher';

// Mode 1: Select existing attendee to transfer management only
// Mode 2: Enter transfer code to transfer management & event ticket together

export default {
  props: [],
  data: () => ({
    mode: 'select',
    error_message: '',
    ready: false,
    attendee: {},
    code: '',
    excode: '238FJHEP',
    code_error_messages: [],
    error_message: '',
    rules: {
      required: value => !!value || 'Required.',
      reasonable_length: value =>
        (value.length >= 8 && value.length <= 10) || 'Between 8-10 characters',
    },
    finished: false,
  }),
  methods: {
    cancel_confirm() {
      this.$data.mode = 'select';
      this.$data.code = '';
    },
    lookup() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      fetcher
        .get('/myprofile/team_manager_invite_lookup', {
          params: {
            full_transfer_code: this.$data.code,
            event_id: this.$route.params.event_id,
          },
        })
        .then(res => {
          if (res.data.success) {
            this.$data.code_error_messages = [];
            this.$data.mode = 'confirm';
            this.$data.attendee = res.data.attendee;
          } else {
            this.$data.code_error_messages = res.data.message;
          }
        });
    },
    confirm() {
      fetcher
        .put('/myprofile/team_manager_invite', {
          event_id: this.$route.params.event_id,
          team_id: this.$route.params.team_id,
          full_transfer_code: this.$data.code,
        })
        .then(res => {
          if (res.data.success) {
            this.$data.error_messages = [];
            this.$data.mode = 'complete';
            this.$data.attendee = {};
          } else {
            this.$data.error_messages = this.data.message;
          }
        });
    },
  },
  beforeMount: async function() {
    let t1 = this.$store.dispatch('loadEvents');
    let t2 = this.$store.dispatch('loadAttendees');
    let t3 = this.$store.dispatch('loadEventTeams', {
      event_id: this.$route.params.event_id,
    });

    await t1;
    await t2;
    await t3;
  },
  computed: {
    ...mapState(['events', 'event_teams', 'myprofile']),
    mode_select() {
      return this.$data.mode == 'select';
    },
    mode_confirm() {
      return this.$data.mode == 'confirm';
    },
    mode_complete() {
      return this.$data.mode == 'complete';
    },
    team() {
      if (!!!this.event_teams) {
        return undefined;
      }
      return this.event_teams?.find(x => {
        return x.id == this.$route.params.team_id;
      });
    },
    event() {
      if (!!!this.events) {
        return undefined;
      }
      return this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      });
    },
    team_attendees() {
      if (!!!this.event_teams) {
        return undefined;
      }
      let tteam = this.event_teams?.find(x => {
        return x.id == this.$route.params.team_id;
      });
      if (!!tteam) {
        return tteam.room_allocations.map(ra => ra.attendees).flat();
      } else {
        return [];
      }
    },
    user_agent() {
      return navigator.userAgent;
    },
  },
  watch: {},
};
</script>

<style>
.choices:nth-child(even) {
  background: #ddd;
}
.choices:nth-child(odd) {
  background: #fff;
}
</style>
